document.addEventListener("DOMContentLoaded", () => {
  // Listen for changes on product option inputs
  document.querySelectorAll("[data-product-option]").forEach(input => {
    input.addEventListener("change", (e) => {
      const optionIndex = e.target.getAttribute("data-product-option");
      const value = e.target.value;

      // Find the corresponding .option-swatch-value span
      const swatchValueEl = document.querySelector(
        `.option-swatch-value[data-option-swatch-value="${optionIndex}"]`
      );

      if (swatchValueEl) {
        swatchValueEl.textContent = value;
      }
    });
  });
});
